import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1.5 text-xs text-secondary-500 md:text-sm">
      <Link to="/" className="flex items-center gap-1 whitespace-nowrap transition-colors hover:text-primary-600">
        <i className="ri-home-4-line"></i>
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-secondary-400"></i>
          {item.to ? (
            <Link to={item.to} className="whitespace-nowrap transition-colors hover:text-primary-600">
              {item.label}
            </Link>
          ) : (
            <span className="max-w-[220px] truncate text-foreground-700 md:max-w-none">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}